<!-- 物流公司编辑页面 -->
<template>
    <div v-loading="loading">
        <div class="form-main">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-width="120px"
                class="formData"
            >
                <div class="formData-top">
                    <div class="form-left form-column">
                        <el-form-item
                            label="名称"
                            prop="Name"
                        >
                            <el-input
                                v-model="formData.Name"
                                :disabled="isReadOnly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="QQ">
                            <el-input
                                v-model="formData.QQ"
                                :disabled="isReadOnly"
                                :maxlength="20"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-center form-column">
                        <el-form-item
                            label="联系人"
                            prop="Contacts"
                        >
                            <el-input
                                v-model="formData.Contacts"
                                :disabled="isReadOnly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话">
                            <el-input
                                v-model="formData.Telephone"
                                :maxlength="20"
                                :disabled="isReadOnly"
                            ></el-input>
                        </el-form-item>

                    </div>
                    <div class="form-right form-column">
                        <el-form-item
                            label="手机号"
                            prop="Phone"
                        >
                            <el-input
                                v-model="formData.Phone"
                                :maxlength="20"
                                :disabled="isReadOnly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="传真">
                            <el-input
                                v-model="formData.Fax"
                                :disabled="isReadOnly"
                                :maxlength="20"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="formData-bottom">
                    <div>
                        <el-form-item label="省市区">
                            <el-select
                                v-model="formData.Province"
                                style="width: 160px"
                                filterable
                                clearable
                                value-key="ProvinceName"
                                @change="provinceChange"
                                placeholder="请选择省"
                                :disabled="isReadOnly"
                            >
                                <el-option
                                    v-for="item in provinceList"
                                    :key="item.ProvinceId"
                                    :label="item.ProvinceName"
                                    :value="item"
                                ></el-option>
                            </el-select>
                            <el-select
                                v-model="formData.City"
                                style="width: 160px;margin-left:10px;"
                                filterable
                                clearable
                                value-key="CityName"
                                @change="cityChange"
                                placeholder="请选择市"
                                :disabled="isReadOnly"
                            >
                                <el-option
                                    v-for="item in cityList"
                                    :key="item.CityId"
                                    :label="item.CityName"
                                    :value="item"
                                ></el-option>
                            </el-select>
                            <el-select
                                v-model="formData.District"
                                style="width: 160px;margin-left:10px;"
                                filterable
                                clearable
                                value-key="DistrictName"
                                @change="zoneChange"
                                placeholder="请选择区"
                                :disabled="isReadOnly"
                            >
                                <el-option
                                    v-for="item in zoneList"
                                    :key="item.DistrictId"
                                    :label="item.DistrictName"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div>
                      <el-form-item label="分配仓库" style="margin-left: 8px;">
                        <el-tooltip class="item" effect="dark" :content="warehouseName" placement="top" v-if="type == 3 && formData.WarehouseSId.length > 1">
                          <el-select
                            v-model="formData.WarehouseSId"
                            :disabled="isReadOnly"
                            placeholder="请选择仓库"
                            style="width: 190px"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            class="tags-select-input"
                          >
                              <el-option
                                  v-for="optionItem in warehouseList"
                                  :key="optionItem.WarehouseId"
                                  :label="optionItem.WarehouseName"
                                  :value="optionItem.WarehouseId"
                              >
                                  <span style="float: left">
                                      {{ optionItem.WarehouseName }}
                                  </span>
                                  <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                              </el-option>
                          </el-select>
                        </el-tooltip>
                        <el-select
                            v-model="formData.WarehouseSId"
                            :disabled="isReadOnly"
                            placeholder="请选择仓库"
                            style="width: 190px"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            class="tags-select-input"
                            v-else
                          >
                              <el-option
                                  v-for="optionItem in warehouseList"
                                  :key="optionItem.WarehouseId"
                                  :label="optionItem.WarehouseName"
                                  :value="optionItem.WarehouseId"
                              >
                                  <span style="float: left">
                                      {{ optionItem.WarehouseName }}
                                  </span>
                                  <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                              </el-option>
                          </el-select>
                      </el-form-item>
                    </div>
                </div>
                <div class="formData-bottom">
                    <el-form-item label="详细地址">
                        <el-input
                            v-model="formData.AddrDetail"
                            style="width: 500px"
                            maxlength="180"
                            :disabled="isReadOnly"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="优先级" style="margin-left: 8px;">
                        <!-- <el-input
                            v-model="formData.Priority"
                            style="width: 190px"
                            maxlength="180"
                            :disabled="isReadOnly"
                        ></el-input> -->
                        <el-select
                          v-model="formData.Priority"
                          :disabled="isReadOnly"
                          placeholder="请选择优先级"
                          style="width: 190px"
                          filterable
                          clearable
                        >
                            <el-option
                                v-for="item in priorityList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                                <span style="float: left" if="formData.Priority != 0">
                                    {{ item.label }}
                                </span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
            <div
                class="dialog-footer"
                v-if="!isReadOnly"
            >
                <el-button
                    class="btn-primary"
                    @click="submitForm"
                >提交</el-button>
                <el-button @click="cancel()">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "",
  props: ["type", "compId"], // type 1 新增 2 编辑 3查看
  data() {
    return {
      loading: true,
      isReadOnly: false,
      formData: {
        Id: "",
        Name: "",
        Contacts: "",
        QQ: "",
        Phone: "",
        Telephone: "",
        Fax: "",
        ProvinceId: "",
        CityId: "",
        DistrictId: "",
        AddrDetail: "",
        Province: "",
        City: "",
        District: "",
        WarehouseSId:[],
        WarehouseSIds:"",
        Priority:"",
      },
      rules: {
        Name: [
          {
            required: true,
            message: "该项必填",
            trigger: "blur"
          }
        ],
        Contacts: [
          {
            required: true,
            message: "该项必填",
            trigger: "blur"
          }
        ],
        Phone: [
          {
            required: true,
            message: "该项必填",
            trigger: "blur"
          }
        ]
      },
      provinceList: [],
      cityList: [],
      zoneList: [],
      warehouseList:[],
      priorityList:[{
        value:1,
        label:'特急'
      },{
        value:2,
        label:'紧急'
      },{
        value:3,
        label:'普通'
      },{
        value:4,
        label:'不急'
      }],
      warehouseName:"",
    };
  },
  mounted() {
    this.getWarehouse();
    if (this.type == 3) {
      this.isReadOnly = true;
      this.getEntpLogCompany();
    } else if (this.type == 2) {
      this.getEntpLogCompany();
    } else {
      this.getProvinceList("54416925-01EE-40A2-A536-DA142C06F5E8");
      this.loading = false;
    }
  },
  watch: {
    'formData.WarehouseSId'(newVal, oldVal) {
      this.warehouseName = "";
      if(this.formData.WarehouseSId.length > 1){
        for(var i = 0;i<this.formData.WarehouseSId.length;i++){
        let index = this.warehouseList.findIndex(f => f.WarehouseId === this.formData.WarehouseSId[i]);
        if(index != -1){
            this.warehouseName =  this.warehouseName+this.warehouseList[index].WarehouseName+(i+1 != this.formData.WarehouseSId.length?",":"");
        }
      }
      }
    },
  },
  methods: {
    getEntpLogCompany() {
      let that = this;
      that.$util
        .axiosGet({
          url: "/api/EntpCustomers/GetEntpLogCompany",
          data: { id: this.compId },
          hideLoading: true
        })
        .then(res => {
          let data = res.data;
          that.formData = data;
          if(that.formData.WarehouseSId.length > 0){
              if(that.formData.WarehouseSId[0] == ""){
                that.formData.WarehouseSId = [];
              }
          }
          if(that.formData.Priority == 0){
            that.formData.Priority = "";
          }
          if (that.type == 3) {
            if (data.ProvinceId)
              that.provinceList.push({
                ProvinceId: data.ProvinceId,
                ProvinceName: data.Province
              });
            if (data.CityId)
              that.cityList.push({ CityId: data.CityId, CityName: data.City });
            if (data.DistrictId)
              that.zoneList.push({
                DistrictId: data.DistrictId,
                DistrictName: data.District
              });
          } else {
            that.getProvinceList("54416925-01EE-40A2-A536-DA142C06F5E8");
            if (data.ProvinceId) {
              that.getCityList(data.ProvinceId);
            }
            if (data.CityId) {
              that.getZoneList(data.CityId);
            }
          }

          that.loading = false;
        })
        .catch(() => {
          that.loading = false;
        });
    },
    getProvinceList(CountryId) {
      return new Promise((resolve, reject) => {
        this.$util
          .axiosGet({
            url: "/api/Region/GetProvinceList",
            data: {
              CountryId: CountryId
            },
            hideLoading: true
          })
          .then(res => {
            this.provinceList = res.data;
            resolve();
          })
          .catch(() => {});
      });
    },
    getCityList(ProvinceId) {
      return new Promise((resolve, reject) => {
        this.$util
          .axiosGet({
            url: "/api/Region/GetCityList",
            data: {
              ProvinceId: ProvinceId
            },
            hideLoading: true
          })
          .then(res => {
            this.cityList = res.data;
            resolve();
          })
          .catch(() => {});
      });
    },
    getZoneList(CityId) {
      this.$util
        .axiosGet({
          url: "/api/Region/GetDistrictList",
          data: {
            CityId: CityId
          },
          hideLoading: true
        })
        .then(res => {
          this.zoneList = res.data;
        })
        .catch(() => {});
    },
    // 获取仓库列表
    getWarehouse() {
      this.$util.getWarehouse().then(data => {
          this.warehouseList = data;
      });
    },
    provinceChange(value) {
      this.formData.ProvinceId = value.ProvinceId;
      this.formData.CityId = "";
      this.formData.City = {};
      this.formData.DistrictId = "";
      this.formData.District = {};
      this.getCityList(value.ProvinceId);
    },
    cityChange(value) {
      this.formData.CityId = value.CityId;
      this.formData.DistrictId = "";
      this.formData.District = {};
      this.getZoneList(value.CityId);
    },
    zoneChange(value) {
      this.formData.DistrictId = value.DistrictId;
      this.formData.District = value.DistrictName;
    },
    cancel() {
      this.$emit("closeDialog");
    },
    submitForm() {
      this.$refs.formData.validate(valid => {
        let that = this;
        if (valid) {
          that.formData.WarehouseSIds="";
          for(var i =0;i<that.formData.WarehouseSId.length;i++){
            that.formData.WarehouseSIds = that.formData.WarehouseSIds + that.formData.WarehouseSId[i] + ",";
          }
          that.loading = true;
          that.$util
            .axiosPost({
              url: "/api/EntpCustomers/EditEntpLogCompany",
              data: that.formData,
              hideLoading: true
            })
            .then(() => {
              if (that.type == 1) {
                that.$util.successMsg("添加成功");
              } else {
                that.$util.successMsg("修改成功");
              }
              that.$emit("closeDialog", "edit");
            })
            .finally(() => {
              that.loading = false;
            });
        } else {
          this.$util.errorMsg("校验不通过");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.formData-bottom {
  display: flex;
}
.form-value {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
}
.form-column {
  width: 33.33%;
}
.formData-top {
  display: flex;
}
.dialog-footer {
  text-align: right;
}
.addicon {
  height: 30px;
  margin-left: 10px;
  margin-top: 5px;
}
.tags-select-input{
  height:40px;
}
.tags-select-input /deep/ .el-select__tags{
  height: 40px;
  white-space: nowrap;
  overflow: hidden;
  flex-wrap: nowrap;
}
.tags-select-input /deep/ .el-select__tags-text{
  display: inline-block;
  max-width: 85px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tags-select-input /deep/ .el-tag__close{
  margin-top: -15px !important;
}
</style>